export const BUSINESS_TZ = 'Africa/Tunis';

const loc = (l: string) => (l === 'ar' ? 'ar-TN-u-nu-latn' : l === 'en' ? 'en-GB' : 'fr-TN');

/** `YYYY-MM-DD` (API date) to a readable date. Parsed as UTC noon so the timezone never shifts the day. */
export function formatDate(v: string | null | undefined, locale: string): string {
  if (!v) return '—';
  const d = new Date(`${v.slice(0, 10)}T12:00:00Z`);
  return new Intl.DateTimeFormat(loc(locale), { day: '2-digit', month: 'short', year: 'numeric', timeZone: 'UTC' }).format(d);
}

export function formatDateTime(v: string | null | undefined, locale: string): string {
  if (!v) return '—';
  return new Intl.DateTimeFormat(loc(locale), { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: BUSINESS_TZ }).format(new Date(v));
}

export function formatRelative(v: string, locale: string): string {
  const diff = (new Date(v).getTime() - Date.now()) / 1000;
  const rtf = new Intl.RelativeTimeFormat(loc(locale), { numeric: 'auto' });
  const abs = Math.abs(diff);
  if (abs < 60) return rtf.format(Math.round(diff), 'second');
  if (abs < 3600) return rtf.format(Math.round(diff / 60), 'minute');
  if (abs < 86400) return rtf.format(Math.round(diff / 3600), 'hour');
  return rtf.format(Math.round(diff / 86400), 'day');
}

/** Today in the business timezone as YYYY-MM-DD. */
export const todayTunis = () => new Date().toLocaleDateString('en-CA', { timeZone: BUSINESS_TZ });
export const addDays = (days: number) => new Date(Date.now() + days * 86400000).toLocaleDateString('en-CA', { timeZone: BUSINESS_TZ });
